(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0200', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var nota = data[i];
                    transformResponse(nota);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.inicioVigencia) {
                    data.inicioVigencia = DateUtils.convertLocaleDateFromServer(data.inicioVigencia);
                }
                return data;
            }

            var resource = $resource('/api/arquivo-desif-registro-0200/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0200/consultar',
                    isArray: true,
                    transformResponse: transformResponseList
                }
            });

            return resource;
        });
})();
